export const excludedRoutes = [
    'blogPost', 
    'creditDetails', 
    'editProductPlanner',
    'eSLogin',
    'invoiceDetails',
    'processingOnlineOrderDetails',
    'pplQuoteDetails',
    'quoteDetails',
    'sPLogin',
    'Wishlist',
];